import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState, JobIdentity } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { CheckCircle2 } from "lucide-react";

export default function PartKomplit() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/jobs?status=Complete").then((r) => setJobs(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Part Komplit" subtitle="Nopol/PO yang seluruh Required Parts sudah datang lengkap." />
      {loading ? <Spinner /> : jobs.length === 0 ? <EmptyState title="Belum ada job komplit" icon={CheckCircle2} /> : (
        <div className="grid gap-3">
          {jobs.map((j) => {
            const s = j.parts_summary || {};
            return (
              <Card key={j.id} className="p-4 cursor-pointer hover:shadow-sm" onClick={() => navigate(`/jobs/${j.id}`)} data-testid={`komplit-${j.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <JobIdentity job={j} />
                  <StatusBadge status="PARTS_COMPLETE" />
                </div>
                <div className="text-xs text-gray-500 mt-2">Total {s.total} item • Required {s.required} • Received {s.received} • {j.job_number}</div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
